import React from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SITE } from "@/data/site";
import { LogOut, FileText, PlusCircle, ExternalLink, User, Newspaper } from "lucide-react";

const AdminLayout = () => {
    const { user, logout } = useAuth();
    const nav = useNavigate();

    const doLogout = () => {
        logout();
        nav("/admin/login");
    };

    return (
        <div className="min-h-screen bg-[var(--acd-bg-soft)]">
            <header className="bg-[var(--acd-navy-900)] text-white">
                <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
                    <Link
                        to="/admin"
                        className="flex items-center gap-3"
                        data-testid="admin-logo"
                    >
                        <img
                            src={SITE.logoUrl}
                            alt="ACD Advogados"
                            className="h-10 bg-white/95 rounded p-1"
                        />
                        <div>
                            <div className="text-xs uppercase tracking-widest text-[var(--acd-gold)]">
                                Área Administrativa
                            </div>
                            <div className="text-sm font-semibold">
                                ACD Advogados
                            </div>
                        </div>
                    </Link>
                    <div className="flex items-center gap-4">
                        <Link
                            to="/"
                            className="hidden md:inline-flex items-center gap-2 text-sm text-white/70 hover:text-white transition"
                            target="_blank"
                            data-testid="admin-view-site"
                        >
                            <ExternalLink size={14} /> Ver site
                        </Link>
                        <div className="hidden md:flex items-center gap-2 text-sm text-white/80">
                            <User size={14} />
                            <span>{user?.name || user?.email}</span>
                        </div>
                        <button
                            onClick={doLogout}
                            className="inline-flex items-center gap-2 text-sm bg-white/10 hover:bg-white/20 transition px-3 py-2 rounded-lg"
                            data-testid="admin-logout"
                        >
                            <LogOut size={14} /> Sair
                        </button>
                    </div>
                </div>
            </header>

            <div className="max-w-7xl mx-auto px-6 py-8">
                <div className="grid md:grid-cols-[220px_1fr] gap-8">
                    <aside>
                        <nav className="bg-white rounded-xl p-2 border border-gray-100 sticky top-6">
                            <div className="px-3 py-1.5 text-xs uppercase tracking-widest text-[color:var(--acd-muted)] font-bold mb-1">
                                Conteúdo
                            </div>
                            <Link
                                to="/admin"
                                className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-semibold text-[var(--acd-navy-900)] hover:bg-[var(--acd-bg-soft)] transition"
                                data-testid="admin-nav-articles"
                            >
                                <FileText size={16} /> Artigos
                            </Link>
                            <Link
                                to="/admin/artigos/novo"
                                className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-semibold text-[var(--acd-navy-900)] hover:bg-[var(--acd-bg-soft)] transition"
                                data-testid="admin-nav-new-article"
                            >
                                <PlusCircle size={16} /> Novo artigo
                            </Link>
                            <div className="px-3 py-1.5 text-xs uppercase tracking-widest text-[color:var(--acd-muted)] font-bold mt-3 mb-1">
                                Imprensa
                            </div>
                            <Link
                                to="/admin/press"
                                className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-semibold text-[var(--acd-navy-900)] hover:bg-[var(--acd-bg-soft)] transition"
                                data-testid="admin-nav-press"
                            >
                                <Newspaper size={16} /> Press & Media
                            </Link>
                            <Link
                                to="/admin/press/novo"
                                className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-semibold text-[var(--acd-navy-900)] hover:bg-[var(--acd-bg-soft)] transition"
                                data-testid="admin-nav-new-press"
                            >
                                <PlusCircle size={16} /> Novo item
                            </Link>
                        </nav>
                    </aside>
                    <main>
                        <Outlet />
                    </main>
                </div>
            </div>
        </div>
    );
};

export default AdminLayout;
